module.exports = __webpack_public_path__ + "assets/img/box_yes.772e70c8.svg";